// API base URL - use relative paths so it works on any domain
// The /api prefix is routed to the backend by the ingress/proxy
export const API_URL = '';
